export default __webpack_public_path__ + "static/media/bagasoo.58e29750.png";